import type { IDecimalValueAndUnit, IDocument, IHaulageJobFormCreate } from '@/interfaces'
import HaulagePricingMethod from '@/enum/HaulagePricingMethod'
import PriceWithUnit from '../PriceWithUnit'

class HaulageJobFormCreate implements IHaulageJobFormCreate {
  description: string | null
  customerId: string | null
  wasteCollectionProviderId: string | null
  requestDates: string[] | null
  price: IDecimalValueAndUnit
  pricingMethod: HaulagePricingMethod
  purchaseOrderDocuments: IDocument[]
  purchaseOrderNumber: string | null
  assignedEmployeeId: string | null
  assignedVehicleId: string | null
  assignedEquipmentId: string | null

  constructor(jobData?: any) {
    this.description = jobData?.description ?? null
    this.customerId = jobData?.customerId ?? null
    this.wasteCollectionProviderId = jobData?.wasteCollectionProviderId ?? null
    this.requestDates = jobData?.requestDates ?? null
    this.price = new PriceWithUnit(jobData?.price)
    this.purchaseOrderDocuments = jobData?.purchaseOrderDocuments ?? []
    this.purchaseOrderNumber = jobData?.purchaseOrderNumber ?? null
    this.assignedEmployeeId = jobData?.assignedEmployeeId ?? null
    this.assignedVehicleId = jobData?.assignedVehicleId ?? null
    this.assignedEquipmentId = jobData?.assignedEquipmentId ?? null
    this.pricingMethod = jobData?.pricingMethod || HaulagePricingMethod.PerLoad
  }
}

export default HaulageJobFormCreate
